import { type Page_opportunitiesUsernameQuery } from '#app/__generated__/relay/Page_opportunitiesUsernameQuery.graphql.js';
import { ProfileOpportunities } from '#app/features/profile/components/ProfileOpportunities/ProfileOpportunities.js';
import { ProfileLayout } from '#app/features/profile/layouts/ProfileLayout.js';
import { useRegisterAnalyticEvent } from '#app/hooks/useRegisterAnalyticEvent.js';
import { type PageProps } from '#app/types/router.js';
import { graphql, usePreloadedQuery } from '@contra/relay';
import { Helmet } from 'react-helmet-async';

type ProfileOpportunitiesPageProps = PageProps<
  '/@username/opportunities',
  Page_opportunitiesUsernameQuery
>;

export const Page = ({ preloaded }: ProfileOpportunitiesPageProps) => {
  const data = usePreloadedQuery<Page_opportunitiesUsernameQuery>(
    graphql`
      query Page_opportunitiesUsernameQuery($username: String!) {
        visitor {
          id
          userAccount {
            ...ProfileLayout_userAccount
          }
        }
        userProfileByUsername(username: $username) {
          id
          firstName
          lastName
          ...ProfileLayout_userProfile
          ...ProfileOpportunities_userProfile
          visitorCanEdit
        }
      }
    `,
    preloaded,
  );
  const { userProfileByUsername: profile, visitor } = data;

  useRegisterAnalyticEvent(
    profile && !profile.visitorCanEdit
      ? {
          eventType: 'UserProfileView',
          input: { userProfileId: profile.id },
        }
      : undefined,
  );

  if (profile === null) return null;

  return (
    <>
      <Helmet>
        <title>{`Opportunities offered by ${profile.firstName} ${profile.lastName}`}</title>
      </Helmet>
      <ProfileLayout
        accountRef={visitor.userAccount}
        userProfileRef={profile}
      >
        <ProfileOpportunities profileKey={profile} />
      </ProfileLayout>
    </>
  );
};
